import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Send, Loader2, CheckCircle2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Lightweight newsletter capture — email only, no signup.
 * Used to catch pro visitors not ready to create an account.
 */
export default function NewsletterOptin({ source = "landing", compact = false }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      await axios.post(`${API}/api/newsletter/subscribe`, { email, source });
      setDone(true);
      toast.success("Merci ! Vous recevrez les prochains articles techniques.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur d'envoi");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div
        className={`flex items-center gap-2 text-sm ${compact ? "" : "rounded-xl border border-up/40 bg-up/10 px-4 py-3"}`}
        data-testid="newsletter-done"
      >
        <CheckCircle2 size={16} className="text-up" />
        <span className="text-white/80">Inscription confirmée — à très bientôt.</span>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      className={compact ? "flex gap-2 items-center" : "rounded-xl border border-white/10 bg-black/30 p-5"}
      data-testid="newsletter-form"
    >
      {!compact && (
        <div className="mb-3">
          <div className="text-xs uppercase tracking-widest text-accent-blue mb-1 flex items-center gap-1.5">
            <Mail size={12} /> Newsletter technique
          </div>
          <div className="text-sm text-white/70">
            1 email/mois. Nouveaux articles Academy · méthodologie quant · updates produit.
            Aucun spam, aucune revente. Désinscription en 1 clic.
          </div>
        </div>
      )}
      <div className={compact ? "flex-1" : "mt-3 flex gap-2"}>
        <input
          type="email" required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="vous@example.com"
          className="field flex-1"
          data-testid="newsletter-email-input"
        />
        {!compact && (
          <button
            type="submit"
            disabled={busy}
            className="btn btn-primary text-sm px-4 py-2.5 disabled:opacity-40"
            data-testid="newsletter-submit"
          >
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />} S&apos;inscrire
          </button>
        )}
      </div>
      {compact && (
        <button
          type="submit"
          disabled={busy}
          className="btn btn-primary text-sm px-4 py-2.5 disabled:opacity-40"
          data-testid="newsletter-submit-compact"
        >
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}
        </button>
      )}
    </form>
  );
}
